<template>
  <HrmisCrudModule v-bind="config" />
</template>

<script>
import HrmisCrudModule from "./HrmisCrudModule.vue";

export default {
  name: "ModuleRedeployment",
  components: { HrmisCrudModule },
  data() {
    return {
      config: {
        title: "Redeployment",
        subtitle: "Redeploy employees across departments/stations",
        icon: "🔄",
        listFunction: "getRedeploymentList",
        saveFunction: "saveRedeployment",
        permissionViewCodes: ["REDEPLOYMENT_VIEW", "REDEPLOYMENT_MANAGE"],
        permissionManageCodes: ["REDEPLOYMENT_MANAGE"],
        addButtonLabel: "Add Employee Redeployment",
        employeeInputMode: "search",
        loadEmployees: true,
        loadDepartments: true,
        columns: [
          { key: "employee_name", label: "Employee" },
          { key: "current_department_name", label: "Current Department" },
          { key: "target_department_name", label: "Redeployed To" },
          { key: "effective_date", label: "Effective Date" },
          { key: "status", label: "Status" }
        ],
        fields: [
          { key: "employee_id", label: "Employee", type: "employee", required: true, lockOnEdit: true },
          { key: "target_department_id", label: "Target Department", type: "department", required: true },
          { key: "effective_date", label: "Effective Date", type: "date", required: true },
          { key: "station", label: "Station / Work Location", type: "text" },
          { key: "reason", label: "Reason for redeployment", type: "textarea" },
          {
            key: "status",
            label: "Status",
            type: "select",
            options: ["Draft", "Pending", "Approved", "Rejected", "Implemented"],
            default: "Draft"
          }
        ]
      }
    };
  }
};
</script>
